import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { type Position } from './types'
import { faker } from '@faker-js/faker'
import axios from 'axios'
import { API } from '@/config'

const apiURL: string = API

const api = axios.create({
  baseURL: apiURL + '/v1'
})

export const usePositionStore = defineStore('position', () => {
  const positions = reactive(Array<Position>())
  const selectedPosition = ref({} as Position) // selected in table
  const thisPosition = ref({} as Position) //for form editing

  const showForm = ref(false)


  function generatePositions(count = 100) {

  }

  async function savePosition(payload: Position) {
    if (payload.uuid) {
      const response = (await api.put('/positions/' + payload.uuid, payload))

      if (response.status == 200) {
        const idx = positions.findIndex(item=>item.uuid == payload.uuid)
        positions.splice(idx,1,response.data.data)
      } else {
      }
    } else {
      const response = (await api.post('/positions.json', payload))

      if (response.status == 200) {
        positions.push(response.data)
      } else {
      }
    }
  }


  async function addPosition(payload: Position) {
    const response = (await api.post('/positions.json', payload))

    if (response.status == 200) {
      positions.push(response.data)
    } else {
    }


  }

  async function deletePosition(payload: Position) {
    const response = (await api.delete('/positions/' + payload.uuid))

    if (response.status == 200) {
      const idx = positions.findIndex(item=>item.uuid == payload.uuid)
      positions.splice(idx,1)
    } else {
    }


  }

  const positionName = computed(()=>(uuid: string)=>{
    return positions.find((item: Position)=>item.uuid == uuid)?.name

  })

  const positionUuid = computed(()=>(name: string)=>{
    return positions.find((item: Position)=>item.name.toLocaleLowerCase() == name.toLocaleLowerCase())?.uuid

  })

  async function getPositions() {

    const response = (await api.get('/positions.json'))
    if (response.status == 200) {
      positions.length=0
      response.data.data.forEach((item: Position)=>{
        positions.push(item)
      })
      
    } else {
    }
  }



  return {
    showForm,
    positions,
    selectedPosition,
    thisPosition,
    generatePositions,
    getPositions,
    savePosition,
    addPosition,
    deletePosition,

    positionName,
    positionUuid
  }
})
